import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import styles from './HomeUserJobsDashboard.module.css';
import jobstyles from "../JobDashboard/NewHomeUserJobsDashboard.module.css";
import { API_BASE_URL } from '../../config';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import Loader2 from '../../components/loader2';
import DashboardNavbar from '../../components/Navbar/navbar-dashboard';
import { Card, CardContent, CardHeader, CardTitle } from "../../_newprofiles/components/ui/Card"
import { Separator } from "../../_newprofiles/components/ui/Separator"
import { Badge } from "../../_newprofiles/components/ui/Badge"
import { User, MapPin, Clock, DollarSign, MessageSquare, ArrowLeft } from "lucide-react"
import Dropdown from '../../components/Dropdown/Dropdown';
import Modal from '../../components/Modal/Modal';
import ModernJobReview from '../JobReview/ModernJobReview';
import ModernNavbarPureCSS from "../../components/Navbar/ModernNavBarPureCSS";
import { User as UserIcon } from "lucide-react"; // Renamed to avoid conflict with existing User import
import { NavLink as RouterNavLink, useLocation, useNavigate } from 'react-router-dom'; // Keep useLocation import, add useNavigate
import { useRef } from 'react'; // Import useRef

// --- MODIFICATION 1: IMPORT THE BUSINESS PROFILE PANEL ---
import BusinessProfilePureCSS from '../../profiles/BusinessProfilePureCSS';

const HomeUserJobsDashboard = () => {
  const navigate = useNavigate(); // Initialize useNavigate
  const [jobsdata, setJobsdata] = useState([]);
  const [jobsCompleteData, setJobsCompleteData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
  const [selectedJob, setSelectedJob] = useState(null);
  const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);
  const [username, setUsername] = useState('');
  const [statusFilter, setStatusFilter] = useState("default"); // New state for status filter
  const jobCardRefs = useRef({}); // Ref to store job card DOM elements
  const [isJobDetailsVisible, setIsJobDetailsVisible] = useState(false);

// --- MODIFICATION: ADD STATE FOR IMAGE MODAL ---
const [isImageModalOpen, setIsImageModalOpen] = useState(false);
const [selectedImageIndex, setSelectedImageIndex] = useState(0);
const [jobImages, setJobImages] = useState([]);

// --- Renamed 'location' to 'currentLocation' to resolve linting error ---
const currentLocation = useLocation();

  // --- MODIFICATION 2: ADD STATE FOR THE BUSINESS PROFILE PANEL ---
  const [isBusinessProfileOpen, setIsBusinessProfileOpen] = useState(false);
  const [selectedBusinessId, setSelectedBusinessId] = useState(null);


  const openReviewModal = () => setIsReviewModalOpen(true);
  const closeReviewModal = () => setIsReviewModalOpen(false);


// --- MODIFICATION: ADD FUNCTIONS FOR IMAGE MODAL ---
const openImageModal = (images, index) => {
  setJobImages(images.filter(img => img)); // Filter out null/empty images
  setSelectedImageIndex(index);
  setIsImageModalOpen(true);
};

const closeImageModal = () => {
  setIsImageModalOpen(false);
};


  // --- MODIFICATION 3: ADD HANDLERS FOR THE BUSINESS PROFILE PANEL ---
  const openBusinessProfile = (businessId) => {
    setSelectedBusinessId(businessId);
    setIsBusinessProfileOpen(true);
  };

  const closeBusinessProfile = () => {
    setIsBusinessProfileOpen(false);
    setSelectedBusinessId(null);
  };


  // --- MODIFICATION START: Functions updated to accept 'event' ---
  const nextImage = (event) => {
    event.stopPropagation(); // Stop event from bubbling to the overlay
    setSelectedImageIndex((prevIndex) => (prevIndex + 1) % jobImages.length);
  };

  const prevImage = (event) => {
    event.stopPropagation(); // Stop event from bubbling to the overlay
    setSelectedImageIndex((prevIndex) => (prevIndex - 1 + jobImages.length) % jobImages.length);
  };


  // Function to store selected job ID in session storage
  const storeSelectedJobId = (jobId) => {
    sessionStorage.setItem('selectedJobId', jobId);
  };

  // Function to retrieve selected job ID from session storage
  const getStoredSelectedJobId = () => {
    return sessionStorage.getItem('selectedJobId');
  };

  const handleStatusChange = async (newStatus) => {
    if (!selectedJob || !selectedJob.job_id) {
      console.error("No job selected for status update.");
      return;
    }

    const jobId = selectedJob.job_id;
    const endpoint = `${API_BASE_URL}/api/Jobs/updatestatus/${jobId}`;

    console.log(`Sending PATCH request to: ${endpoint} with status: ${newStatus}`);

    try {
      await axios.patch(endpoint, { Status: newStatus });
      console.log(`Job ${jobId} status updated to ${newStatus}`);
      // Refresh job data after successful update
      getAllJob();
    } catch (error) {
      console.error("Error updating job status:", error);
      setError("Failed to update job status.");
    }
  };

  const getAllJob = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const token = localStorage.getItem('token');
      if (token) {
        const decodeToken = jwtDecode(token);

        setUsername(decodeToken.UserName || 'User');

        const homeUserId = decodeToken.nameid;
        if (homeUserId) {
          const response = await axios.get(
            `${API_BASE_URL}/api/Jobs/getmyjobs?homeUserId=${homeUserId}`
          );
          const rawJobs = response.data;

          // Normalize API fields to ensure projectId is present for navigation
          const normalizedJobs = Array.isArray(rawJobs)
            ? rawJobs.map(job => {
                const cand = job.projectId ?? job.project_id ?? job.ProjectId ?? (job.project && (job.project.projectId ?? job.project.id));
                let pid = cand;
                if (pid === undefined || pid === null) {
                  pid = null;
                } else if (typeof pid === 'string') {
                  const t = pid.trim().toLowerCase();
                  if (t === '' || t === 'null' || t === 'undefined') {
                    pid = null;
                  } else {
                    const n = Number(t);
                    pid = Number.isNaN(n) ? null : n;
                  }
                } else if (typeof pid === 'number') {
                  pid = Number.isFinite(pid) ? pid : null;
                }
                return { ...job, projectId: pid };
              })
            : [];
          
          const getReversedJobs = (statuses) => {
            if (!Array.isArray(statuses)) {
              statuses = [statuses];
            }
            return normalizedJobs.filter((job) => statuses.includes(job.jobStatus)).reverse();
          };

          const allJobs = [...getReversedJobs(['Assigned', 'Pending', 'Open', 'Completed', 'Archived'])]; // Fetch all statuses
          setJobsdata(allJobs);

          const storedJobId = getStoredSelectedJobId();
          if (storedJobId) {
            const previouslySelectedJob = allJobs.find(job => job.job_id.toString() === storedJobId);
            if (previouslySelectedJob) {
              setSelectedJob(previouslySelectedJob);
            } else {
              // If stored job not found (e.g., archived or deleted), select default
              const defaultFilteredJobs = allJobs.filter(job => job.jobStatus !== "Archived");
              if (defaultFilteredJobs.length > 0) {
                setSelectedJob(defaultFilteredJobs[0]);
              } else if (allJobs.length > 0) {
                setSelectedJob(allJobs[0]);
              }
            }
          } else {
            // Set selected job based on the default filter (no archived jobs)
            const defaultFilteredJobs = allJobs.filter(job => job.jobStatus !== "Archived");
            if (defaultFilteredJobs.length > 0) {
              setSelectedJob(defaultFilteredJobs[0]);
            } else if (allJobs.length > 0) {
              // If no non-archived jobs, select the first available job
              setSelectedJob(allJobs[0]);
            }
          }

        } else {
          setError("Could not find user ID in token.");
        }
      } else {
        setError("No token found. Please log in.");
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getAllJob();
  }, []);
  
  // This useEffect handles the selectedJob passed from the dashboard
  useEffect(() => {
    // Use the renamed currentLocation variable
    const jobFromState = currentLocation.state?.selectedJob;
    
    // Ensure that jobsdata has been loaded before trying to find the job
    if (jobFromState && jobsdata.length > 0) {
      const jobToSelect = jobsdata.find(j => j.job_id === jobFromState.job_id);
      if (jobToSelect) {
        // Use your existing function to select the job and trigger scrolling
        handleJobClick(jobToSelect);
      }
    }
  }, [currentLocation.state, jobsdata]); // Dependency on currentLocation.state

  useEffect(() => {
    if (selectedJob && jobCardRefs.current[selectedJob.job_id]) {
      jobCardRefs.current[selectedJob.job_id].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      });
    }
  }, [selectedJob, jobsdata]); // Re-run when selectedJob or jobsdata changes

  const handleJobClick = (job) => {
    setSelectedJob(job);
    storeSelectedJobId(job.job_id.toString());
    setIsJobDetailsVisible(true);
  };

  const handleBackToList = () => {
    setIsJobDetailsVisible(false);
  };

  const handleSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const sortedAndFilteredJobs = () => {
    let itemsToFilter = [...jobsdata];

    // Apply status filter
    if (statusFilter === "default") {
      itemsToFilter = itemsToFilter.filter(job => job.jobStatus !== "Archived");
    } else if (statusFilter === "Open") {
      itemsToFilter = itemsToFilter.filter(job => job.jobStatus === "Open");
    } else if (statusFilter === "Completed") {
      itemsToFilter = itemsToFilter.filter(job => job.jobStatus === "Completed");
    } else if (statusFilter === "Pending") {
      itemsToFilter = itemsToFilter.filter(job => job.jobStatus === "Pending");
    }
    // "All" filter means no status filtering, which is handled by not adding a filter condition here.

    if (searchTerm) {
      itemsToFilter = itemsToFilter.filter(job =>
        job.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        job.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (job.profession && job.profession.some(p => p.name.toLowerCase().includes(searchTerm.toLowerCase())))
      );
    }

    if (sortConfig.key !== null) {
      itemsToFilter.sort((a, b) => {
        let valA = a[sortConfig.key];
        let valB = b[sortConfig.key];

        if (sortConfig.key === 'created_at') {
          valA = new Date(a.created_at);
          valB = new Date(b.created_at);
        } else if (sortConfig.key === 'budgetAmount') {
          valA = Number(a.budgetAmount) || 0;
          valB = Number(b.budgetAmount) || 0;
        } else if (sortConfig.key === 'category') {
          valA = a.profession && a.profession.length > 0 ? a.profession[0].name.toLowerCase() : '';
          valB = b.profession && b.profession.length > 0 ? b.profession[0].name.toLowerCase() : '';
        }

        if (valA < valB) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (valA > valB) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }
    return itemsToFilter;
  };

  const currentFilteredJobs = sortedAndFilteredJobs();

  const stats = {
    totalJobs: jobsdata.length,
    activeJobs: jobsdata.filter((job) => job.jobStatus === "Assigned" || job.jobStatus === "Open").length,
    pendingJobs: jobsdata.filter((job) => job.jobStatus === "Pending").length,
    completedJobs: jobsdata.filter((job) => job.jobStatus === "Completed").length,
    totalBudget: (jobsdata).reduce((sum, job) => sum + (Number.parseInt(job.budgetAmount) || 0), 0),
    totalQuotes: (jobsdata).reduce((sum, job) => sum + (job.quoteCount || 0), 0),
  };

  const getSortIndicator = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'ascending' ? ' ▲' : ' ▼';
    }
    return '';
  };

  return (
    <>
    
        <ModernNavbarPureCSS UserName={username} prefix={''} TabActiveId={'jobs'} />
    
    <div style={{ paddingTop: '1px' }} className={styles.jobDashboard_minHeightScreen + ' ' + styles.jobDashboard_bgGradientBlueAmber}>
      {/* Header */}
      <header className={jobstyles.jobDashboard_bgGradientHeader + ' ' + jobstyles.jobDashboard_header} style={{ position: 'sticky', top: 0, zIndex: 1020 }}>
        <div className={jobstyles.jobDashboard_container}>
          <div className={jobstyles.bizjobDashboard_headerContent}>
            <div className={jobstyles.jobDashboard_headerLeft}>
              <div className={jobstyles.jobDashboard_headerLogo}>
                <h1 className={jobstyles.jobDashboard_text2xl + ' ' + jobstyles.jobDashboard_fontBold}>Job Dashboard</h1>
              </div>
            </div>

            <div className={styles.jobDashboard_headerRight}>
              <NavLink to="/job-detail-new" className={styles.jobDashboard_btn + ' ' + styles.jobDashboard_mascotButton + ' ' + styles.jobDashboard_fontSemibold}>
                <span className={styles.jobDashboard_h4 + ' ' + styles.jobDashboard_w4 + ' ' + styles.jobDashboard_mr2}>➕ </span>
                Post New Job &nbsp; &nbsp;
              </NavLink>
            </div>

          </div>
        </div>
      </header>

      <div className={styles.jobDashboard_container + ' ' + styles.jobDashboard_py8}>
        {/* Stats Cards */}
        <div className={`${styles.jobDashboard_grid} ${styles.jobDashboard_gridCols1} ${styles.jobDashboard_md_gridCols2} ${styles.jobDashboard_lg_gridCols4} ${styles.jobDashboard_gap6} ${styles.jobDashboard_mb8} ${styles.statsContainer}`}>
          <div className={styles.jobDashboard_card + ' ' + styles.jobDashboard_bgGradientBlueCard + ' ' + styles.jobDashboard_statCard}>
            <div className={styles.jobDashboard_statCardContent}>
              <div className={styles.jobDashboard_statCardText}>
                <p className={styles.jobDashboard_statCardLabel}>Total Projects</p>
                <p className={styles.jobDashboard_statCardValue}>{stats.totalJobs}</p>
                <p className={styles.jobDashboard_statCardSubtitle}>{stats.activeJobs} active</p>
              </div>
              <span className={styles.jobDashboard_statCardIcon }>📄</span>
            </div>
          </div>
          <div className={styles.jobDashboard_card + ' ' + styles.jobDashboard_bgGradientAmberCard + ' ' + styles.jobDashboard_statCard}>
            <div className={styles.jobDashboard_statCardContent}>
              <div className={styles.jobDashboard_statCardText}>
                <p className={styles.jobDashboard_statCardLabel}>Total Quotes</p>
                <p className={styles.jobDashboard_statCardValue}>{stats.totalQuotes}</p>
                <p className={styles.jobDashboard_statCardSubtitle}>From contractors</p>
              </div>
              <span className={styles.jobDashboard_statCardIcon + ' ' + styles.jobDashboard_textAmber200}>💬</span>
            </div>
          </div>
          <div className={styles.jobDashboard_card + ' ' + styles.jobDashboard_bgGradientGreenCard + ' ' + styles.jobDashboard_statCard}>
            <div className={styles.jobDashboard_statCardContent}>
              <div className={styles.jobDashboard_statCardText}>
                <p className={styles.jobDashboard_statCardLabel}>Total Spend</p>
                <p className={styles.jobDashboard_statCardValue}>${(stats.totalBudget / 1000).toFixed(0)}K</p>
                <p className={styles.jobDashboard_statCardSubtitle}>Across all projects</p>
              </div>
              <span className={styles.jobDashboard_statCardIcon + ' ' + styles.jobDashboard_textGreen200}>💰</span>
            </div>
          </div>
          <div className={styles.jobDashboard_card + ' ' + styles.jobDashboard_bgGradientPurpleCard + ' ' + styles.jobDashboard_statCard}>
            <div className={styles.jobDashboard_statCardContent}>
              <div className={styles.jobDashboard_statCardText}>
                <p className={styles.jobDashboard_statCardLabel}>Completed</p>
                <p className={styles.jobDashboard_statCardValue}>{stats.completedJobs}</p>
                <p className={styles.jobDashboard_statCardSubtitle}>Successfully finished</p>
              </div>
              <span className={styles.jobDashboard_statCardIcon + ' ' + styles.jobDashboard_textPurple200}>✅</span>
            </div>
          </div>
        </div>

        {/* Search and Filter */}
        <div className={styles.jobDashboard_card + ' ' + styles.jobDashboard_mb8}>
          <div className={styles.jobDashboard_cardContent}>
            <div className={styles.jobDashboard_searchFilterContainer}>
              <div className={styles.jobDashboard_searchInputContainer}>
                <span className={styles.jobDashboard_searchInputIcon + ' ' + styles.jobDashboard_textGray400}>🔍</span>
                <input
                  type="text"
                  placeholder="Search by name, description, category..."
                  className={styles.jobDashboard_input + ' ' + styles.jobDashboard_searchInputMain}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)} />
              </div>
              <div className={styles.jobDashboard_filterButtons}>
                <Dropdown
                  placeholder="Filter by Status"
                  options={[
                    { value: "default", label: "Default (No Archived)" },
                    { value: "All", label: "Show All Jobs" },
                    { value: "Open", label: "Show Open Jobs" },
                    { value: "Completed", label: "Show Completed Jobs" },
                    { value: "Pending", label: "Show Pending Jobs" },
                  ]}
                  onSelect={setStatusFilter}
                  styles={styles.Dropdown}
                />
                <button className={styles.jobDashboard_btn + ' ' + styles.jobDashboard_btnOutline + ' ' + styles.jobDashboard_btnSm} onClick={() => handleSort('created_at')}>
                  <span className={styles.jobDashboard_h4 + ' ' + styles.jobDashboard_w4 + ' ' + styles.jobDashboard_mr2}>📅</span>
                  Sort by Date{getSortIndicator('created_at')}
                </button>
                <button className={styles.jobDashboard_btn + ' ' + styles.jobDashboard_btnOutline + ' ' + styles.jobDashboard_btnSm} onClick={() => handleSort('budgetAmount')}>
                  <span className={styles.jobDashboard_h4 + ' ' + styles.jobDashboard_w4 + ' ' + styles.jobDashboard_mr2}>💰</span>
                  Sort by Budget{getSortIndicator('budgetAmount')}
                </button>
                <button className={styles.jobDashboard_btn + ' ' + styles.jobDashboard_btnOutline + ' ' + styles.jobDashboard_btnSm} onClick={() => handleSort('category')}>
                  <span className={styles.jobDashboard_h4 + ' ' + styles.jobDashboard_w4 + ' ' + styles.jobDashboard_mr2}>🏷️</span>
                  Sort by Category{getSortIndicator('category')}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Jobs Layout */}
        <div className={`${styles.jobsLayout} ${isJobDetailsVisible ? styles.detailsVisible : ''}`}>
          {/* Jobs List */}
          <div className={styles.jobsList}>
            {isLoading && <Loader2 />}
            {!isLoading && error && <p>Error: {error}</p>}
            {!isLoading && !error && currentFilteredJobs.map((job) => (
              <Card
                key={job.job_id}
                ref={el => jobCardRefs.current[job.job_id] = el} // Assign ref
                className={`${styles.jobCard} ${selectedJob && selectedJob.job_id === job.job_id ? styles.jobCardSelected : ""}`}
                onClick={() => handleJobClick(job)}
              >
                <CardContent className={styles.jobCardContent}>
                  <div className={styles.jobCardGrid}>
                    <div className={styles.jobCardMain}>
                      <div className={styles.jobTitleContainer}>
                        <h3 className={styles.jobTitle}>{job.name}</h3>
                        {job.deadline === "Urgently" && (
                          <Badge variant="destructive" className={styles.urgentBadge}>
                            Urgent
                          </Badge>

                        )}
                      </div>

                      <div className={styles.jobMeta}>
                        <div className={styles.jobMetaItem}>
                          <User className="h-4 w-4" />
                          <span>{`${job.homeUserFirstName || 'N/A'} ${job.homeUserLastName || ''}`}</span>
                        </div>
                        <div className={styles.jobMetaItem}>
                          <MapPin className="h-4 w-4" />
                          <span>{job.postcode}</span>
                        </div>
                        <div className={styles.jobMetaItem}>
                          <Clock className="h-4 w-4" />
                          <span>{new Date(job.created_at).toLocaleDateString()}</span>
                        </div>
                      </div>
                      <p className={styles.jobDescription}>{job.description}</p>

                        {/* --- MODIFICATION 4A: CONVERT LINK TO BUTTON --- */}
                        {job.assignedBusinessId && (
                          <button
                            type="button"
                            onClick={(e) => {
                              e.stopPropagation(); // Prevent card click event
                              openBusinessProfile(job.assignedBusinessId);
                            }}
                            className={styles.assignedBusinessTile}
                          >
                            <UserIcon className={styles.assignedBusinessTileIcon} />
                            <span className={styles.assignedBusinessTileText}>Assigned to {job.businessName}</span>
                          </button>
                        )}
                        {job.projectId && (
                          <button
                            type="button"
                            onClick={(e) => {
                              e.stopPropagation(); // Prevent card click event
                              console.log("HomeUserJobsDashboard - job object:", JSON.stringify(job, null, 2)); // DEBUG LOG
                              console.log("HomeUserJobsDashboard - job.projectId:", job.projectId, "job.job_id:", job.job_id); // Debug log
                              navigate(`/project/${job.projectId}/${job.job_id}`);
                            }}
                            className={styles.viewProjectButton}
                          >
                            View Project
                          </button>
                        )}
                    </div>
                    <div className={styles.jobCardAside}>
                      <div className={styles.jobBudget}>
                        <DollarSign className="h-4 w-4" />
                        <span>{job.budgetAmount ? `$${job.budgetAmount}` : job.budget}</span>
                      </div>



<div className={styles.jobStats}>
    {/* Use a ternary operator to conditionally apply the correct style */}
    <div className={job.quoteCount > 0 ? styles.quoteHighlightBadge : styles.jobStatItem}>
        <MessageSquare className="h-4 w-4" />
        {/* Added logic for correct pluralization ("quote" vs "quotes") */}
        <span>{job.quoteCount} {job.quoteCount === 1 ? 'quote' : 'quotes'}</span>
    </div>
</div>


                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* Job Details Panel */}
          <div className={styles.jobDetailsPanel}>
            {selectedJob && (
              <Card className={styles.detailsCard}>
                <CardHeader className={styles.detailsCardHeader}>
                  <CardTitle className={styles.detailsCardTitle}>
                    <button className={styles.backButton} onClick={handleBackToList}>
                      <ArrowLeft size={24} />
                    </button>
                    <span>Job Details</span>
                    <div className={styles.headerActions}>
                      <RouterNavLink to={`/job-detail-new/${selectedJob.job_id}`} className={styles.editJobButton}>
                        Edit Job
                      </RouterNavLink>
                      <Dropdown
                        placeholder="Actions"
                        options={[
                          ...(selectedJob.assignedBusinessId !== null
                            ? [{ value: "Completed", label: "Mark as Complete" }]
                            : []),
                          { value: "Open", label: "Mark as Open" },
                          { value: "Archived", label: "Mark as Archived" },
                        ]}
                        onSelect={handleStatusChange}
                        styles={styles.Dropdown}
                      />
                    </div>
                  </CardTitle>
                </CardHeader>
                <CardContent className={styles.detailsCardContent}>
                  <div className={styles.detailsContent}>
                    <div className={styles.detailsSection}>
                      <h3 className={styles.detailsTitle}>{selectedJob.name}</h3>
                      <p className={styles.detailsDescription}>{selectedJob.description}</p>

                        {/* --- MODIFICATION 4B: CONVERT LINK TO BUTTON --- */}
                        {selectedJob.assignedBusinessId && (
                          <button
                            type="button"
                            onClick={() => openBusinessProfile(selectedJob.assignedBusinessId)}
                            className={styles.assignedBusinessTile}
                          >
                            <UserIcon className={styles.assignedBusinessTileIcon} />
                            <span className={styles.assignedBusinessTileText}>Assigned to {selectedJob.businessName}</span>
                          </button>
                        )}
                        {selectedJob.projectId && (
                          <button
                            type="button"
                            onClick={() => {
                              console.log("HomeUserJobsDashboard - selectedJob object:", JSON.stringify(selectedJob, null, 2)); // DEBUG LOG
                              console.log("HomeUserJobsDashboard - selectedJob.projectId:", selectedJob.projectId, "selectedJob.job_id:", selectedJob.job_id); // Debug log
                              navigate(`/project/${selectedJob.projectId}/${selectedJob.job_id}`);
                            }}
                            className={styles.viewProjectButton}
                          >
                            View Project
                          </button>
                        )}
                    </div>
                    <Separator />
                    <div className={styles.detailsGrid}>
                      <div className={styles.detailItem}>
                        <h4 className={styles.detailLabel}>Budget</h4>
                        <p className={`${styles.detailValue} ${styles.detailValueBudget}`}>{selectedJob.budgetAmount ? `$${selectedJob.budgetAmount}` : selectedJob.budget}</p>
                      </div>
                      <div className={styles.detailItem}>
                        <h4 className={styles.detailLabel}>Deadline</h4>
                        <p className={styles.detailValue}>{selectedJob.deadline}</p>
                      </div>
                      <div className={styles.detailItem}>
                        <h4 className={styles.detailLabel}>Category</h4>
                        <p className={styles.detailValue}>{selectedJob.profession && selectedJob.profession.length > 0 ? selectedJob.profession[0].name : "General"}</p>
                      </div>
                       <div className={styles.detailItem}>
                        <h4 className={styles.detailLabel}>Status</h4>
                        <p className={`${styles.detailValue} ${styles.detailValueBudget}`}>{selectedJob.jobStatus}</p>
                      </div>
                    </div>
                    <Separator />
                    {(selectedJob.image1 || selectedJob.image2 || selectedJob.image3 || selectedJob.image4) && (
                      <>
                        <div className={styles.detailsSection}>
                          <h4 className={styles.detailLabel}>Project Images</h4>
                          <div className={styles.projectImagesGrid}>

{/* --- MODIFICATION: ADD ONCLICK TO IMAGES --- */}
                                                {[selectedJob.image1, selectedJob.image2, selectedJob.image3, selectedJob.image4].map((image, index) => (
                                                    image && 
                                                      <img 
                                                        key={index} 
                                                        src={image} 
                                                        alt={`Project image ${index + 1}`} 
                                                        className={styles.projectImage} 
                                                        onClick={() => openImageModal([selectedJob.image1, selectedJob.image2, selectedJob.image3, selectedJob.image4], index)} 
                                                      />
                                                ))}

                                                            
                          </div>
                        </div>
                        <Separator />
                      </>
                    )}
                      {selectedJob.jobStatus === 'Completed' && (
                        <button onClick={openReviewModal} className={styles.addReviewButton}>
                          {selectedJob.reviewId ? "View Review" : "Add Review"}
                        </button>
                      )}
                      {selectedJob.quoteCount > 0 && (
                        <RouterNavLink
                          to={`/job/${selectedJob.job_id}/quotes`}
                          className={`${styles.addReviewButton} ${styles.viewQuotesButton}`}
                        >
                          <MessageSquare className={`${jobstyles.jobDetailNew_iconBase} ${jobstyles.jobDetailNew_buttonIconMr2}`} />
                          View Quotes ({selectedJob.quoteCount})
                        </RouterNavLink>
                      )}
                  </div>
                </CardContent>
              </Card>
            )}
          </div>
        </div>
      </div>
      {isReviewModalOpen && (
        <Modal isOpen={isReviewModalOpen} onClose={closeReviewModal}>
          <ModernJobReview
            isPopup={true}
            jobId={selectedJob.job_id}
            businessId={selectedJob.assignedBusinessId}
            jobDescription={selectedJob.description}
            businessName={selectedJob.businessName}
            userName={username}
            reviewId={selectedJob.reviewId}
            onClose={closeReviewModal}
          />
        </Modal>
      )}

      {/* --- MODIFICATION: RENDER IMAGE MODAL --- */}
      {isImageModalOpen && (
        <Modal isOpen={isImageModalOpen} onClose={closeImageModal}>
          <div className={styles.imageModalContent}>
            <button className={styles.imageModalCloseButton} onClick={closeImageModal}>&times;</button>
            <button className={styles.imageModalNavButton + ' ' + styles.imageModalPrevButton} onClick={prevImage}>&#10094;</button>
            {jobImages.length > 0 && selectedImageIndex < jobImages.length && (
              <img src={jobImages[selectedImageIndex]} alt={`Enlarged project image ${selectedImageIndex + 1}`} className={styles.imageModalImage} />
            )}
            <button className={styles.imageModalNavButton + ' ' + styles.imageModalNextButton} onClick={nextImage}>&#10095;</button>
          </div>
        </Modal>
      )}
    </div>
    
    
      {/* --- MODIFICATION 5: RENDER THE BUSINESS PROFILE PANEL --- */}
      <BusinessProfilePureCSS
        isOpen={isBusinessProfileOpen}
        onClose={closeBusinessProfile}
        businessId={selectedBusinessId}
        useIDTYPE={"BID"}
      />
    
    
    
    </>
  );
};

export default HomeUserJobsDashboard;
